function initProductBuyBottomScroll() {
  const navBox = document.querySelector('.product-buy-bottom');
  const headerBox = document.querySelector('.nav');
  const productNav = document.querySelector('.product-nav');
  
  // 1. 安全获取 parentElement，防空指针报错
  const parentElement = productNav ? productNav.parentNode : null;

  // 2. 初始化 parentElement 基础样式
  if (parentElement) {
    parentElement.style.position = 'sticky';
    parentElement.style.zIndex = '1000';
    // 动态获取 Header 初始高度
    const initHeaderHeight = headerBox ? headerBox.offsetHeight : 0;
    parentElement.style.top = `${initHeaderHeight}px`;
    // 给 top 添加平滑过渡，匹配 Header 的显隐动画
    parentElement.style.transition = 'top 0.3s ease';
  }

  let scrollTimer = null;
  let lastScrollTop = 0;
  let isHeaderVisible = true; // 状态标志位：避免重复触发 DOM 修改

  const handleScroll = () => {
    const scrollTop = Math.max(0, window.scrollY || document.documentElement.scrollTop);

    // ================= 1. headerBox & parentElement 联动逻辑 =================
    if (headerBox) {
      // 动态获取 Header 当前高度，防止不同设备/展开状态高度变化
      const headerHeight = headerBox.offsetHeight || 56;

      // 往下滑动超过 50px：隐藏 Header
      if (scrollTop > lastScrollTop && scrollTop > 50) {
        if (isHeaderVisible) { // 仅在状态改变时触发一次
          isHeaderVisible = false;
          headerBox.classList.remove('is-show');
          headerBox.classList.add('is-hide');
          if (parentElement) parentElement.style.top = '0px';
        }
      } 
      // 往上滑动：显示 Header
      else if (scrollTop < lastScrollTop) {
        if (!isHeaderVisible) { // 仅在状态改变时触发一次
          isHeaderVisible = true;
          headerBox.classList.remove('is-hide');
          headerBox.classList.add('is-show');
          if (parentElement) parentElement.style.top = `${headerHeight}px`;
        }
      }
    }

    // 更新滚动位置
    lastScrollTop = scrollTop;

    // ================= 2. navBox (底部购买栏) 逻辑 =================
    if (!navBox) return;

    // 每次滚动时动态判断是否为移动端
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (!isMobile) {
      navBox.classList.remove('is-show');
      return;
    }

    // 滑动过程中立刻隐藏 navBox
    navBox.classList.remove('is-show');

    if (scrollTimer !== null) {
      clearTimeout(scrollTimer);
    }

    // 停止滑动 200ms 后判断位置并决定是否显示 navBox
    scrollTimer = setTimeout(() => {
      const targetSection = document.querySelector('.product__info-wrapper');

      if (targetSection) {
        // 计算目标模块底部的绝对位置，并减去一个屏幕的高度 (window.innerHeight)
        const sectionBottom = targetSection.offsetTop + targetSection.offsetHeight;
        const triggerPoint = sectionBottom - window.innerHeight;

        // 当滚动距离超过 (模块底部 - 1屏高度) 时，触发显示
        if (scrollTop >= triggerPoint) {
          navBox.classList.add('is-show');
        }
      } else {
        if (scrollTop > 300) {
          navBox.classList.add('is-show');
        }
      }
    }, 200);
  };

  // 监听全局滚动事件
  window.addEventListener('scroll', handleScroll, { passive: true });
}

// 兼容 ES Module 的安全加载判定
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductBuyBottomScroll);
} else {
  initProductBuyBottomScroll();
}